import { Grid, Typography } from '@mui/material';
import React from 'react';
import { LightTooltip } from '../../../../../../lib/designSystem/WhiteTooltip';
import { companySizes } from '../../../../../BusinessProfile/Profile/components/Client/components/constants';

const GridRow = ({
  label,
  value,
  sizes,
  maxLength,
}: {
  label: string;
  value: string;
  sizes?: number[];
  maxLength?: number;
}) => {
  const textToShow = maxLength
    ? value.length > maxLength
      ? value.slice(0, maxLength) + '...'
      : value
    : value;
  return (
    <>
      <Grid item xs={sizes?.[0] || 4}>
        <Typography fontWeight={600}>{label}:</Typography>
        <Grid item xs={sizes?.[1] || 8}>
          <LightTooltip title={<Typography padding={1}>{value}</Typography>}>
            <Typography>{textToShow}</Typography>
          </LightTooltip>
        </Grid>
      </Grid>
    </>
  );
};

type CommercialYearSummary = {
  businessIdentifier: string;
  businessName: string;
  collaborators: number;
  commune: string;
  constributorType: string;
  constributorSubType: string;
  economicActivity: string;
  economicSegment: string;
  economicSubSegment: string;
  finalizedDate: string;
  firstCreatedDate: string;
  minSalesSegment: number;
  maxSalesSegment: number;
  ownCapitalNegativeSegment: string;
  ownCapitalPositiveSegment: string;
  province: string;
  region: string;
  salesSegment: number;
  termType: string;
  year: number;
};

type Props = {
  commercialYearSummary: CommercialYearSummary;
};

function LastYearSummay({ commercialYearSummary }: Props) {
  const {
    businessIdentifier,
    businessName,
    collaborators,
    commune,
    economicSegment,
    economicSubSegment,
    firstCreatedDate,
    minSalesSegment,
    maxSalesSegment,
    province,
    region,
    constributorSubType,
    salesSegment,
    year,
  } = commercialYearSummary;
  const salesSegmentName =
    companySizes.find((size) => size.id === salesSegment)?.name || '';
  return (
    <div style={{ padding: '20px 0px' }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <GridRow
            label="Razón social"
            value={businessName}
            sizes={[2, 10]}
            maxLength={40}
          />
          <GridRow label="Región" value={region} maxLength={40} />

          <GridRow
            label="Segmento económico"
            value={economicSegment}
            sizes={[2, 10]}
            maxLength={40}
          />

          <GridRow
            label="Inicio actividades"
            value={firstCreatedDate.slice(0, 10)}
            maxLength={40}
          />
          <GridRow
            label="Tramo según ventas"
            value={`${salesSegment} (${salesSegmentName})`}
            sizes={[2, 10]}
            maxLength={40}
          />
          <GridRow
            label={`Ventas mínimas (${year})`}
            value={`$${minSalesSegment.toLocaleString('es-CL')}`}
            sizes={[2, 10]}
            maxLength={40}
          />
        </Grid>
        <Grid item xs={6}>
          <GridRow label="Rut" value={businessIdentifier} maxLength={40} />
          <GridRow
            label="Comuna"
            value={`${commune} (${province})`}
            maxLength={40}
          />

          <GridRow
            label="Subsegmento económico"
            value={economicSubSegment}
            sizes={[2, 10]}
            maxLength={40}
          />
          <GridRow
            label={`Tipo de contribuyente (${year})`}
            value={`${constributorSubType}`}
            sizes={[2, 10]}
            maxLength={40}
          />
          <GridRow
            label="Número de trabajadores"
            value={collaborators.toString()}
            maxLength={40}
          />

          <GridRow
            label={`Ventas máximas (${year})`}
            value={`$${maxSalesSegment.toLocaleString('es-CL')}`}
            sizes={[2, 10]}
            maxLength={40}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default LastYearSummay;
